<div class="tw-flex tw-row tw-header-show" style="width: 100%">
  <div class="tw-header-font" style="position: relative">
    <div style="position: absolute;right: -8px;top:-8px;
                display: flex;flex-direction: row;
                justify-content: center;align-items: center;">
      <mat-icon color="primary">event</mat-icon>
      @if (reservation.quantity>0) {
        <span class="tw-header-number">{{reservation.quantity}}</span>
      }
    </div>

    <div style="font-weight: 600">
      {{reservation.eventTitle}}
    </div>
    <div style="font-weight: 600">
      {{"reservation.eventDate"|translate}} : {{reservation.eventStart | twDatePipe:'longDate'}}
    </div>
    <div>
      {{"reservation.quantity"|translate}} : {{reservation.quantity}}
    </div>
    @if (reservation.expDate) {
      <div>
        {{"reservation.expDate"|translate}} : {{reservation.expDate | twDatePipe:'longDate'}}
      </div>
    }
  </div>
</div>
